import { render } from "./UserSettingsDialog.vue?vue&type=template&id=e58668e2&scoped=true"
import script from "./UserSettingsDialog.vue?vue&type=script&lang=js"
export * from "./UserSettingsDialog.vue?vue&type=script&lang=js"

import "./UserSettingsDialog.vue?vue&type=style&index=0&id=e58668e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58668e2"]])

export default __exports__